<template>
  <el-dialog
    title="Thay đổi mật khẩu"
    :visible="visible"
    @close="handleClose"
    @open="handleOpen"
    :destroy-on-close="true"
    top="5vh"
    width="60%"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="Mật khẩu cũ" prop="oldPassword" :error="errors.oldPassword">
        <el-input v-model="form.oldPassword" show-password></el-input>
      </el-form-item>
      <el-form-item label="Mật khẩu mới" prop="newPassword" :error="errors.newPassword">
        <el-input v-model="form.newPassword" show-password></el-input>
      </el-form-item>
      <el-form-item label="Nhập lại mật khẩu" prop="newPasswordConfirmation" :error="errors.newPasswordConfirmation">
        <el-input v-model="form.newPasswordConfirmation" show-password></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Hủy</el-button>
      <el-button type="primary" @click="handleSubmitForm">Cập nhật</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ChangePasswordModal',
  props: {
    visible: Boolean,
  },
  data() {
    const passwordConfirm = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('Nhập lại mật khẩu phải khớp với mật khẩu mới!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
      },
      errors: {},
      rules: {
        oldPassword: [{ required: true, message: 'Mật khẩu cũ không được để trống', trigger: 'blur' }],
        newPassword: [
          { required: true, message: 'Mật khẩu mới không được để trống', trigger: 'blur' },
          { min: 6, message: 'Mật khẩu mới không được nhỏ hơn 6 ký tự', trigger: 'blur' },
        ],
        newPasswordConfirmation: [
          { required: true, message: 'Nhập lại mật khẩu không được để trống', trigger: 'blur' },
          {
            validator: passwordConfirm,
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    handleSubmitForm() {
      this.errors = {}
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch('auth/changePassword', this.form)
            .then(() => {
              this.handleClose()
            })
            .catch((e) => {
              this.setFormErrors({ oldPassword: e.response?.data?.message || e.message || e })
            })
        }
      })
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    handleOpen() {
      this.form = {
        oldPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
      }
    },
    setFormErrors(errors) {
      setTimeout(() => {
        this.errors = { ...this.errors, ...errors }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
